import AppContext from "PFApp/app_context";
import { useContext, useMemo } from "react";

export const useIsAvailabilityPermitted = (
  profile = null,
  accessLevel = ["rw", "ro"],
  permissionsGroup = null
) => {
  const {
    store: { currentProfile }
  } = useContext(AppContext);

  const selectedProfile = profile || currentProfile;

  const availabilityPermissions = useMemo(() => {
    const internalPermissionsGroup = permissionsGroup || selectedProfile.permissions_group || {};

    return accessLevel.includes(
      (internalPermissionsGroup.cross_group_permissions ||
        currentProfile.permissions_group.cross_group_permissions ||
        {})[internalPermissionsGroup.id]?.profile_fields_access_levels?.availability
    );
  }, [profile, currentProfile]);

  return availabilityPermissions;
};

export default useIsAvailabilityPermitted;
